import PropTypes from 'prop-types'
import classNames from 'classnames'
import NoneAnchor from 'components/NoneAnchor'
import { useBoolean, useOnClickOutside } from 'usehooks-ts'
import { useRef } from 'react'

const ToolboxLayer = ({ children, title }) => {
  const ref = useRef()
  const { value: isOpen, setFalse: close, toggle } = useBoolean(false)
  useOnClickOutside(ref, close)
  return (
    <li className={classNames('menu_my', { on: isOpen })} ref={ref}>
      <NoneAnchor className="link_gnb" onClick={toggle}>
        {title}
      </NoneAnchor>
      <div className="layer_mymenu" onClick={close}>
        {children}
      </div>
    </li>
  )
}

ToolboxLayer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.node,
}

export default ToolboxLayer
